import { delay, generateId, randomBetween } from '../../util/pseudoApi'
import { removeArrayElement, removeObjectKey } from '../../util/state'

let scenes = {}
let slates = {}
let takes = {}

const generateNewScene = () => {
  const scene = {
    id: generateId(),
    sceneNumber: (Object.keys(scenes).length + 1).toString(),
    slates: []
  }
  scenes[scene.id] = scene

  return scenes[scene.id]
}

const generateNewSlate = sceneId => {
  const slate = {
    id: generateId(),
    slateNumber: (scenes[sceneId].slates.length + 1).toString(),
    takes: []
  }
  slates[slate.id] = slate
  scenes[sceneId].slates.push(slate.id)

  return slates[slate.id]
}

const generateNewTake = slateId => {
  const take = {
    id: generateId(),
    takeNumber: (slates[slateId].takes.length + 1).toString()
  }
  takes[take.id] = take
  slates[slateId].takes.push(take.id)

  return takes[take.id]
}

const scenesCount = randomBetween(2, 5)
const slatesCount = randomBetween(2, 5)
const takesCount = randomBetween(2, 5)

for (let sceneIndex = 0; sceneIndex < scenesCount; sceneIndex++) {
  const scene = generateNewScene()

  for (let slateIndex = 0; slateIndex < slatesCount; slateIndex++) {
    const slate = generateNewSlate(scene.id)

    for (let takeIndex = 0; takeIndex < takesCount; takeIndex++) {
      const take = generateNewTake(slate.id)
    }
  }
}

export const getScenes = async () => {
  await delay()
  return JSON.parse(JSON.stringify(scenes))
}

export const getSlates = async () => {
  await delay()
  return JSON.parse(JSON.stringify(slates))
}

export const getTakes = async () => {
  await delay()
  return JSON.parse(JSON.stringify(takes))
}

export const newScene = async () => {
  await delay()
  return JSON.parse(JSON.stringify(generateNewScene()))
}

export const newSlate = async sceneId => {
  await delay()
  return JSON.parse(JSON.stringify(generateNewSlate(sceneId)))
}

export const newTake = async slateId => {

  await delay()
  return JSON.parse(JSON.stringify(generateNewTake(slateId)))
}

export const saveScene = async (id, entry) => {
  scenes[id] = {
    ...entry,
    id,
    slates: scenes[id].slates
  }

  await delay()
  return JSON.parse(JSON.stringify(scenes[id]))
}

export const saveSlate = async (id, entry) => {
  slates[id] = {
    ...entry,
    takes: slates[id].takes
  }

  await delay()
  return JSON.parse(JSON.stringify(slates[id]))
}

export const saveTake = async (id, entry) => {
  takes[id] = entry

  await delay()
  return JSON.parse(JSON.stringify(takes[id]))
}

export const deleteScene = async id => {
  scenes = removeObjectKey(scenes, id)

  await delay()
  return true
}

export const deleteSlate = async (id, sceneId) => {
  slates = removeObjectKey(scenes, id)
  scenes[sceneId].slates = removeArrayElement(scenes[sceneId].slates, id)

  await delay()
  return true
}

export const deleteTake = async (id, slateId) => {
  takes = removeObjectKey(scenes, id)
  slates[slateId].takes = removeArrayElement(slates[slateId].takes, id)

  await delay()
  return true
}


// WEBPACK FOOTER //
// ./services/pseudoApi/script.js